import React from 'react'
import { MatchStatus } from 'protos'

interface MatchStatusSwitchProps {
  status?: MatchStatus | null
  renderPreMatch: () => JSX.Element | null
  renderDuringMatch: () => JSX.Element | null
  renderPostMatch: () => JSX.Element | null
}

const MatchStatusSwitch: React.SFC<MatchStatusSwitchProps> = ({
  status, renderPreMatch, renderDuringMatch, renderPostMatch, ...props
}) => {
  if (status === MatchStatus.MS_UPCOMING) {
    return renderPreMatch()
  } else if (status === MatchStatus.MS_LIVE) {
    return renderDuringMatch()
  } else if (status === MatchStatus.MS_FINISHED || status === MatchStatus.MS_CANCELLED) {
    return renderPostMatch()
  }

  return null
}

export default MatchStatusSwitch
